import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions  } from '@angular/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { ApiSettings } from '../../api.settings';

@Injectable()
export class TechnicalserviceProductPieceService {

  private technicalserviceProductPieceUrl = ApiSettings.API_URL + 'technicalserviceproductpiece';
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers, withCredentials: true });

  constructor(private http: Http, private router: Router) { };

  parseParams(params: any){
    let query : string = "?";
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            if (params[key] instanceof Array){
                query += "where={\""+key+"\":["+params[key].toString()+"]}"
            }else{
                query += key +"="+ params[key];
            }
        }
    }
    return query;
}

  query(params: any): Observable<any> {
      return this.http.get(this.technicalserviceProductPieceUrl + this.parseParams(params), this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  get(id: number): Observable<any> {
      return this.http.get(this.technicalserviceProductPieceUrl +'/'+ id, this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  create(technicalserviceProductPiece: any): Observable<any> {
      return this.http.post(this.technicalserviceProductPieceUrl, technicalserviceProductPiece, this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  update(technicalserviceProductPiece: any): Observable<any> {
      return this.http.put(this.technicalserviceProductPieceUrl +'/'+ technicalserviceProductPiece.id, technicalserviceProductPiece, this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }

  delete(id: number): Observable<any> {
      return this.http.delete(this.technicalserviceProductPieceUrl +'/'+ id, this.options)
                      .map(this.extractData)
                      .catch(this.handleError.bind(this));
  }


  private extractData(res: Response) {
      let body = res.json();
      return body || { };
  }

  private handleError (error: Response | any) {
      if (error.status === 403){
          this.router.navigate(['/login']);
      }
      return Observable.throw(error);
  }

}


// WEBPACK FOOTER //
// ./src/app/technicalservice/services/technicalservice-product-piece.service.ts